import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';

import { useMutation } from '@tanstack/react-query';
import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';
import { useErrorMiddleware } from '../../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';

type UseRetrieveTemporalRouteResponseProps = ServiceResponse<Function, Route>;

export const useRetrieveTemporalRoute = (): UseRetrieveTemporalRouteResponseProps => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const {
    mutate: run,
    isLoading,
    isSuccess,
    isError,
    data: route,
  } = useMutation(
    async (routeId: string) => {
      const response = await routeService.fetchRoute({ routeId });
      return response;
    },
    {
      onSuccess: async (route) => {},
      onError: (err: any) => {
        console.info(`Retrieve Route Error: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading,
    data: route,
    run,
  };
};
